import { decodeHtmlEntity } from '@/utils/product';

const Description = ({ description }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: decodeHtmlEntity(description)
          ?.replaceAll(
            '"{{media url="',
            `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
          )
          ?.replaceAll(`/media/" `, '/media/')
          ?.replaceAll('"}}"', '')
          ?.replaceAll(
            '{{media url=',
            `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
          )
          ?.replaceAll('}}', ''),
      }}
    />
  );
};

export default Description;
